import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { FooterOurStoresComponent } from '../../../app/content/layout/components/general/footer/components/footer-our-stores/footer-our-stores.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<FooterOurStoresComponent> = {
  title: 'Organisms/Footer/Footer Our Stores',
  component: FooterOurStoresComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<FooterOurStoresComponent>;

export const Default: Story = {
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-footer-our-stores')).toBeTruthy();
  },
};
